import { Component, input, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

type Variant = 'primary' | 'primaryDialog' | 'accent' | 'warn' | 'success';

const variantMapper: Record<Variant, string> = {
  primary: 'btn-v2',
  primaryDialog: 'btn-v2 be-btn--xsmall-responsive',
  accent: 'btn-v2',
  warn: 'btn-v2',
  success: 'btn-v2 btn-v2--active',
};

@Component({
  selector: 'app-api-btn',
  imports: [CommonModule],
  templateUrl: './api-btn.component.html',
  styleUrls: ['./api-btn.component.scss'],
})
export class ApiBtnComponent {
  @Input() isSubmitting: boolean;
  @Input() isDisabled: boolean;
  @Input() type: 'button' | 'submit' = 'submit';
  @Input() set variant(variant: Variant) {
    this.btnClass = this.getBtnVariant(variant || 'accent');
  }
  readonly btnId = input.required<string>();
  onClick = output<void>();

  btnClass: string = variantMapper.accent;

  getBtnVariant(variant: Variant): string {
    return variantMapper[variant];
  }
}
